import React, { useState } from "react";
import Flag from "react-world-flags";
import CustomSwitch from "../../../../controls/CustomSwitch";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoWarning } from "react-icons/io5";

export default function RecommendedVaccine({ mainColor, tripCountries }) {
  const [selectedItems, setSelectedItems] = useState([]);

  const vaccineItems = [
    {
      id: 1,
      name: "Imodium",
      desc: "Fast relief from travel-related stomach issues",
      price: "2.55",
    },
    {
      id: 2,
      name: "DEET Repellent",
      desc: "Protection against mosquitoes and insect bites",
      price: "9.00",
    },
    {
      id: 3,
      name: "SPF 50+ sunscreen",
      desc: "Essential for countries with high UV Index",
      price: "16.99",
    },
  ];

  const handleBoxClick = (id, name) => {
    const isAlreadySelected = selectedItems.some((i) => i.id === id);

    if (isAlreadySelected) {
      setSelectedItems((prev) => prev.filter((item) => item.id !== id));
    } else {
      setSelectedItems((prev) => [...prev, { id: id, name: name }]);
    }
  };

  return (
    <div className="vaccine-suggestion-box recommended-box">
      <div className="top-header">
        <p>Recommended</p>
        <IoIosCheckmarkCircle size={18} />
      </div>
      <div className="body">
        <div className="header">
          <p>Pharmacy Recommended</p>
          <div className="flags">
            {tripCountries.map((country) => (
              <div className="flag-container">
                <Flag key={country.code} code={country.code} />
              </div>
            ))}
          </div>
        </div>

        <div className="content">
          <p className="description">
            Prepare for common travel-related issues based on your destinations.
          </p>
          <div className="vaccine-items-wrapper">
            {vaccineItems.map((item) => {
              const isSelected = selectedItems.some((i) => i.id === item.id);
              return (
                <div
                  className={`vaccine-selection-box ${
                    isSelected ? "selected" : ""
                  }`}
                  style={{
                    border: `1px solid ${isSelected ? mainColor : "#cecece"}`,
                  }}
                  key={item.id}
                  onClick={() => handleBoxClick(item.id, item.name)}
                >
                  <div>
                    <p className="title">{item.name}</p>
                    <p className="subtitle">{item.desc}</p>
                  </div>

                  <div className="price-checkmark">
                    <p className="price">
                      {item.price !== "FREE" && "£"}
                      {item.price}
                    </p>
                    {isSelected ? (
                      <IoIosCheckmarkCircle
                        className="checkmark"
                        color={mainColor}
                        size={22}
                      />
                    ) : (
                      <div className="empty-circle"></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
